export default __webpack_public_path__ + "static/media/SPS Logo.14be99b1.png";